export const HERO_MOCKUP_URL =
  'https://cdn.magicpatterns.com/uploads/hd49XcQQXdBfWYLHLNAsN4/ChatGPT_Image_11_sept_2026__15_26_24-removebg-preview.webp';
